import { render, staticRenderFns } from "./InfoAboutDocDate.vue?vue&type=template&id=43139d96&scoped=true&"
import script from "./InfoAboutDocDate.vue?vue&type=script&lang=js&"
export * from "./InfoAboutDocDate.vue?vue&type=script&lang=js&"
import style0 from "./InfoAboutDocDate.vue?vue&type=style&index=0&id=43139d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43139d96",
  null
  
)

export default component.exports